import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';
import { StockComparisonSnapshot } from '../../../../types/StockComparison';

export const useStockComparisonSnapshot = (ticker: string | null) => {
  return useQuery({
    queryKey: ['stockComparisonSnapshot', ticker],
    queryFn: async () => {
      const response = await api.get<StockComparisonSnapshot>('/stock-comparison-snapshot', {
        params: { ticker },
      });
      return response.data;
    },
    enabled: !!ticker,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
